import { render, staticRenderFns } from "./searchList-new.vue?vue&type=template&id=dafe929a&scoped=true"
import script from "./searchList-new.vue?vue&type=script&lang=js"
export * from "./searchList-new.vue?vue&type=script&lang=js"
import style0 from "./searchList-new.vue?vue&type=style&index=0&id=dafe929a&prod&lang=scss"
import style1 from "./searchList-new.vue?vue&type=style&index=1&id=dafe929a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafe929a",
  null
  
)

export default component.exports